import { useCallback, useMemo, useState } from "react";
import Collapse from "../../Utils/Collapse";
import CollapseSwitch from "../../Utils/CollapseSwitch";
import CollapseContent from "../../Utils/CollapseContent";
import OptionInput from "../OptionInput";

const MatrixInputItemCollapse = props => {
  const { id: itemId, label: itemLabel } = props.item;

  const {
    fieldName,
    options,
    isChecked,
    onChange,
    maximumSelectableOptions,
    singleOptionSelection
  } = props;

  const selectedOptionsCount = options.filter(({ id: optionId }) =>
    isChecked({ itemId, optionId })
  ).length;

  const inputType = singleOptionSelection ? "radio" : "checkbox";
  const maxOptionsSelected = selectedOptionsCount >= maximumSelectableOptions;

  const selectedOptionLabels = useMemo(
    () =>
      options.reduce((labels, { id: optionId, name }) => {
        if (isChecked({ itemId, optionId })) labels.push(name);

        return labels;
      }, []),
    [isChecked, itemId, options]
  );

  const [singleOptionJustSelected, setSingleOptionJustSelected] = useState(false);

  const handleOptionChanged = useCallback(
    e => {
      const { checked } = e.target;
      if (singleOptionSelection && checked) {
        setSingleOptionJustSelected(true);
      }

      onChange(e);
    },
    [onChange, singleOptionSelection]
  );

  const shouldCollapse = useCallback(() => {
    if (!singleOptionSelection) return false;

    if (singleOptionJustSelected) {
      setSingleOptionJustSelected(false);
      return true;
    }
  }, [singleOptionJustSelected, singleOptionSelection]);

  return (
    <Collapse
      className="matrix-input-item-collapse"
      expanded
      shouldCollapse={shouldCollapse}
    >
      <CollapseSwitch
        className="btn btn-shadow btn-block padding-sm border-bottom margin-bottom-sm"
        labelClassName="flex-column align-items-start"
      >
        {itemLabel}

        {selectedOptionsCount > 0 && (
          <span className="d-block text-small text-primary">
            {selectedOptionLabels.join(", ")}
          </span>
        )}
      </CollapseSwitch>

      <CollapseContent>
        {options.map(({ id: optionId, name: optionName }) => {
          const name = `${fieldName}-${itemId}`;
          const option = { id: JSON.stringify({ itemId, optionId }), name: optionName };
          const isOptionChecked = isChecked({ itemId, optionId });
          const disabled =
            !singleOptionSelection && !isOptionChecked && maxOptionsSelected;

          return (
            <OptionInput
              key={optionId}
              type={inputType}
              name={name}
              option={option}
              onChange={handleOptionChanged}
              checked={isOptionChecked}
              disabled={disabled}
            />
          );
        })}
      </CollapseContent>
    </Collapse>
  );
};

export default MatrixInputItemCollapse;
